import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Item from '../../components/Form/Item';
import axios from '../../util/Api';
import { Typography, Row, Col } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';

const { Text } = Typography;

const VendorDetail = (props) => {
  const formik = useFormikContext();
  const { authUser } = useSelector(({ auth }) => auth);
  const [loading, setLoading] = useState(true);
  const [vendor, setVendor] = useState({});

  useEffect(() => {
    fetchVendorDetail();
  }, []);

  const fetchVendorDetail = () => {
    setLoading(true);
    const url = `/vendor/detail?id=${authUser.vendor.id}`;
    axios.get(url).then(({ data }) => {
      setVendor(data);
      formik.setFieldValue("vendor", data.id);
      setLoading(false);
    }).catch(err => {});
  }

  return (
    <Item name="Perusahaan" required>
      {loading ? "Sedang memuat perusahaan" : (
        <Row>
          <Col md={6} xs={12}>
            <div className="gx-mb-2">
              <div><Text type="secondary" className="gx-text-muted">Kode</Text></div>
              <div><Text>{vendor.code}</Text></div>
            </div>
          </Col>
          <Col md={18} xs={24}>
            <div className="gx-mb-2">
              <div><Text type="secondary" className="gx-text-muted">Nama Perusahaan</Text></div>
              <div><Text>{vendor.name}</Text></div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="gx-mb-2">
              <div><Text type="secondary" className="gx-text-muted">Kategori</Text></div>
              <div><Text>{vendor.category.label}</Text></div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="gx-mb-2">
              <div><Text type="secondary" className="gx-text-muted">Jenis</Text></div>
              <div><Text>{vendor.type.label}</Text></div>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="gx-mb-2">
              <div><Text type="secondary" className="gx-text-muted">Divisi</Text></div>
              <div><Text>{vendor.division.label}</Text></div>
            </div>
          </Col>
        </Row>
      )}

      <ErrorMessage name="vendor" />
    </Item>
  );
}

export default VendorDetail;